import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import { Menu, MenuItem, Radio } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGridHorizontal, faSortDown } from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { ResourceTableSetups } from "../../../createOrder/createOrderTypes"
import { StandardButton } from "../../../buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    button: {
        color: theme.palette.tailwind.slate[800],
        padding: ".5rem 1rem",
        "& .MuiButton-endIcon>*:nth-of-type(1)": {
            fontSize: ".75rem",
        },
    },
    sortIcon: {
        color: theme.palette.tailwind.slate[500],
        marginTop: "-.25rem",
    },
}))
type SelectSetupProps = Readonly<{
    tableSetups: ResourceTableSetups[]
    selectedSetups: string[]
    onChange: (selected: string[]) => void
}>

export function SelectSetup({ tableSetups, selectedSetups, onChange }: SelectSetupProps) {
    const { classes } = useStyles()

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const handleSelect = (key: string) => {
        onChange([key])
    }

    return (
        <>
            <LocalizedStrict id="create-order-confirm-booking-select-setup">
                <StandardButton
                    color="grey"
                    variant="outlined"
                    size="small"
                    updateDefaultClasses={classes.button}
                    startIcon={<FontAwesomeIcon icon={faGridHorizontal} />}
                    endIcon={<FontAwesomeIcon icon={faSortDown} className={classes.sortIcon} />}
                    onClick={handleOpenMenu}
                    fullWidth={false}
                >
                    Select setup
                </StandardButton>
            </LocalizedStrict>
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleCloseMenu}>
                {tableSetups.map((item) => (
                    <MenuItem key={item.key} onClick={() => handleSelect(item.key)}>
                        <Radio checked={selectedSetups.includes(item.key)} />
                        {item.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}
